import * as React from "react";
import { SingleNavMenuLinkAction as ISingleNavMenuLinkAction } from "../../../pages/identity/useNavMenu";
import clsx from "clsx";
import { Spin } from "antd";

interface Props {
  link: ISingleNavMenuLinkAction;
  index: number;
}
export const SingleNavMenuLinkAction: React.FC<Props> = ({ link }) => {
  return (
    <a
      data-link-id={`${link.id}`}
      className={clsx("relative cursor-pointer", {
        "opacity-50 pointer-events-none": link.disabled,
      })}
      onClick={(e) => {
        e.preventDefault();
        if (!link.disabled && !link.loading) {
          link.onClick();
        }
      }}
    >
      {link.label}
      {link.loading ? <Spin size="small" className="ml-2" /> : null}
    </a>
  );
};
